<template>
  <div class="pages">
    <mt-header title="首页">
    </mt-header>
    <Business :xData="xData" :yDataSame="yDataSame" :yDataRing="yDataRing"></Business>
    <div class="bg"></div>
    <KeyFigures></KeyFigures>
    <div class="bg-line"></div>
    <ReportForm></ReportForm>
    <div class="bg"></div>
    <MyApps></MyApps>
    <div class="bg"></div>
    <Information></Information>
  </div>
</template>
<script>
import { Progress } from 'mint-ui';
import { Toast } from 'mint-ui';
import { Indicator } from 'mint-ui';
import Business from 'com/app/index/business.vue';
import KeyFigures from 'com/app/index/keyFigures.vue';
import ReportForm from 'com/app/index/reportForm.vue';
import MyApps from 'com/app/index/myApps.vue';
import Information from 'com/app/index/information.vue';
export default {
  components: {
    Business,
    KeyFigures,
    MyApps,
    ReportForm,
    Information,

  },
  data() {
    return {
      isFirstEnter: false, // 是否第一次进入，默认false
      headerData: {
        bestTitle: '今日最优',
        worstTitle: '今日最差',
        rankTitle: '比昨天增幅排行',
        bestAreaName: '广州广州广州',
        worstAreaName: '长海长海长海',
        bestData: '6.666',
        worstData: '6.666',
        family: '666666666',
        lastMonth: '6.666',
        lastYear: '6.666',
      },
      initList: [],
      tabActiveType: 1,
      activeType: true,
      xData: [], //X坐标数据
      yDataSame: [], //同比数据
      yDataRing: [], //环比数据
      queryParams: {
        "pageSize": 20,
        "pageNo": 1
      },
    }
  },
  methods: {
    getData2() {
      this.$http.post("/a/wechat/donate/findPageSlDonateRecord", {
        json: JSON.stringify(this.queryParams)
      }).then(res => {
        console.log('res:', res)
      }).catch(error => {
        console.log(error)
      })
    },
    changeLineChart(id) {
      console.log('cityId', id)
      this.activeType = false
      this.getData(id)
    },
    changeDateType(type) {
      this.tabActiveType = type
      if (type === 1) {
        this.headerData.rankTitle = '比昨天增幅排行'
      } else {
        this.headerData.rankTitle = '比上月增幅排行'
      }
      this.getData(type)
    },
    changeType() {
      this.activeType = !this.activeType
    },
    getData(type) {
      Indicator.open();
      this.$http.get(this.$urls.getLineList, {
        type: type,
      }).then((res) => {
        console.log('res.data.data.list:', res.data.data.list)
        Indicator.close()
        this.initList = res.data.data.list;
        this.xData = []
        this.yDataSame = []
        this.yDataRing = []
        this.initList.forEach((i) => {
          this.xData.push(i.date)
          this.yDataSame.push(i.rate)
          this.yDataRing.push(i.ringRatio)
        })
      }).catch(error => {
        Indicator.close()
        console.log(error);
      });
    },
    goToRouter(id) {
      this.$router.push(`/addAreaDetails/${id}`)
    },

  },
  created() {
    // 只有第一次进入或者刷新页面后才会执行此钩子函数
    // 使用keep-alive后（2+次）进入不会再执行此钩子函数
    this.isFirstEnter = true;
    this.getData()
  },
  activated() {
    if (!this.$route.meta.isBack || this.isFirstEnter) {
      // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
      // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
      // this.initList = [] // 把数据清空，可以稍微避免让用户看到之前缓存的数据
      this.getData();
      console.log(('activated,add'))
    }
    // 恢复成默认的false，避免isBack一直是true，导致下次无法获取数据
    this.$route.meta.isBack = false
    // 恢复成默认的false，避免isBack一直是true，导致每次都获取新数据
    this.isFirstEnter = false;

  },
  beforeRouteEnter(to, from, next) {
    //利用路由元信息中的meta字段设置变量，方便在各个位置获取。这就是为什么在meta中定义isBack
    if (from.name == 'addAreaDetails') {
      to.meta.isBack = true;
      //判断是从哪个路由过来的，如果是addAreaDetails过来的，表明当前页面不需要刷新获取新数据，直接用之前缓存的数据即可
    }
    next();
  },

}

</script>
<style lang="less" scoped>
  .bg{
    width: 100%;
    height: 0.22rem;
    background-color:#F3F4F6;
  }
  .bg-line{
    width: 100%;
    height: 0.11rem;
    background-color:#F3F4F6;
  }
</style>
<style lang="less">
@main-color: #43484D;
@main-color-2: #86939E;
@main-color-green: #269513;
@main-color-yellow: #FC9D2E;
.font-family-fn(@family) {
  font-family: @family;
}

::-webkit-scrollbar {
  display: none; //隐藏滚动条，保留鼠标滚动效果
}

.pages {
  -webkit-overflow-scrolling: touch; // ios滑动顺畅
  padding-bottom: 0.7rem;
  .mint-header {
    height: 0.8rem;
    background-color: #0384DF;
    z-index: 9;
    .mint-header-title {
      font-size: 0.36rem;
      font-weight: normal;
      .font-family-fn("PingFang-SC-Medium");
    }
  }
}



</style>



// WEBPACK FOOTER //
// src/views/app/index.vue